<div class="flex relative h-full">
    <div *ngIf="index % 4 !== 0"
        class="absolute left-[-30px] top-0 w-px h-full bg-secondary-button-black max-[576px]:hidden"></div>

    <div class="rounded-xl bg-white w-full">
        <!-- Design 1: Standard Market Card -->
        <div *ngIf="data.cardType === 'standard'"
            class="flex flex-col max-[576px]:border max-[576px]:border-secondary-button-black max-[576px]:rounded-2xl max-[576px]:p-4">
            <!-- Image + Title (thumbnail beside the title below 576px) -->
            <div class="max-[576px]:flex max-[576px]:items-start max-[576px]:gap-3">
                <div class="cursor-pointer overflow-hidden rounded-lg relative mb-4 max-[576px]:mb-0 max-[576px]:w-11 max-[576px]:h-11 max-[576px]:shrink-0"
                    [routerLink]="['/details', data.id]">
                    <img *ngIf="data.imageUrl" [src]="data.imageUrl"
                        class="w-full h-full rounded-lg object-cover absolute z-0 left-0 top-0 blur-md max-[576px]:hidden" />
                    <img *ngIf="data.imageUrl" [src]="data.imageUrl"
                        class="object-contain rounded-lg w-full h-48 relative z-10 max-[576px]:h-full max-[576px]:object-cover" />
                </div>
                <a routerLink="/details/{{data.id}}"
                    class="text-black text-base font-medium line-clamp-2 hover:underline h-[48px] overflow-hidden text-ellipsis [overflow-wrap:anywhere] max-[576px]:h-auto max-[576px]:flex-1 max-[576px]:min-w-0 max-[576px]:font-semibold">
                    {{ data.titleText }}
                </a>
            </div>

            <!-- Options Container with Fixed Height -->
            <div class="h-[70px] mb-8 max-[576px]:h-auto max-[576px]:mt-4 max-[576px]:mb-4">
                <div *ngIf="!isAnyOptionActive()" class="flex flex-col gap-5 max-h-[84px] overflow-y-auto no-scrollbar">
                    <!-- All options in scrollable view -->
                    <div *ngFor="let option of data.options; let i = index"
                        class="flex items-center justify-between gap-5">
                        <h3 (click)="selectedCard(data.id, $any(option).title)"
                            class="text-secondary-text-black text-sm font-medium hover:underline cursor-pointer max-[576px]:min-w-0 max-[576px]:truncate">
                            {{ $any(option).title }}
                        </h3>
                        <div class="flex items-center gap-5 max-[576px]:gap-3 max-[576px]:shrink-0">
                            <p class="text-base font-semibold" [style.color]="getIndicatorColor($any(option).percent)">
                                {{ $any(option).percent }}
                            </p>
                            <!-- Each option row exposes both outcomes as a split Yes / No pill -->
                            <div class="flex items-center gap-1 shrink-0">
                                <button
                                    class="text-sm font-syne font-semibold text-[#13987E] bg-[#1cae9133] rounded-lg py-1 px-3.5 cursor-pointer hover:bg-[#13987E] hover:text-white transition-colors"
                                    (click)="selectedCard(data.id, $any(option).title)">
                                    Yes
                                </button>
                                <button
                                    class="text-sm font-syne font-semibold text-[#DBA900] bg-[#f5d25533] rounded-lg py-1 px-3.5 cursor-pointer hover:bg-[#DBA900] hover:text-white transition-colors"
                                    (click)="selectedCard(data.id, $any(option).title)">
                                    No
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Expanded view logic (keeping for backward compatibility if needed) -->
                <div *ngIf="isAnyOptionActive()" class="animate-fadeIn">
                    <div *ngFor="let option of data.options; let i = index">
                        <div *ngIf="option.showNested">
                            <div class="grid grid-cols-2 items-center justify-between gap-5">
                                <div class="flex flex-col gap-1">
                                    <button (click)="selectedCard(data.id, 'YES')"
                                        class="w-full font-syne text-xs text-[#13987E] bg-[#1cae9133] rounded-lg py-1.5 px-4 font-semibold hover:bg-[#13987E] hover:text-white duration-300 ease-in-out cursor-pointer">
                                        Yes
                                    </button>
                                </div>
                                <div class="flex flex-col gap-1">
                                    <button (click)="selectedCard(data.id, 'NO')"
                                        class="w-full font-syne text-xs text-[#E5B300] bg-[#f5d25533] rounded-lg py-1.5 px-4 font-semibold hover:bg-[#E5B300] hover:text-white duration-300 ease-in-out cursor-pointer">
                                        No
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Footer with Volume and Icons -->
            <div class="flex justify-between">
                <p class="text-xs flex items-center !leading-4 text-secondary-text-black gap-1">
                    ${{ data.volume }} Vol.
                    <ng-container *ngIf="data.frequency">
                        <button class="cursor-pointer">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="text-black opacity-50">
                                <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
                                <path d="M3 3v5h5" />
                            </svg>
                        </button>
                        <span class="text-xs flex items-center !leading-4 text-secondary-text-black gap-1">{{ data.frequency }}</span>
                    </ng-container>
                </p>
                <ul class="flex items-center gap-3.5">
                    <li class="inline-flex bg-transparent rounded-sm cursor-pointer p-1 duration-300 ease-in-out hover:bg-light-black-300">
                        <button class="cursor-pointer" (click)="toggleBookmark($event)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="14" viewBox="0 0 11 14" [attr.fill]="isBookmarked ? 'black' : 'none'">
                                <path d="M0.5 10.242V5.19858C0.5 2.98365 0.5 1.87618 1.2142 1.18809C1.92841 0.5 3.07789 0.5 5.37687 0.5C7.67583 0.5 8.82537 0.5 9.53953 1.18809C10.2537 1.87618 10.2537 2.98365 10.2537 5.19858V10.242C10.2537 11.6477 10.2537 2.3506 9.78264 12.6021C8.87024 13.0893 7.15889 11.4639 6.34615 10.9746C5.8748 10.6907 5.63913 10.5488 5.37687 10.5488C5.11462 10.5488 4.87895 10.6907 4.4076 10.9746C3.59486 11.4639 1.88349 13.0893 0.971137 12.6021C0.5 12.3506 0.5 11.6477 0.5 10.242Z" [attr.stroke]="isBookmarked ? 'black' : 'black'" [attr.stroke-opacity]="isBookmarked ? '1' : '0.5'" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                    </li>
                </ul>
            </div>
        </div>

        <!-- Design 2: Simple Yes/No Card -->
        <div *ngIf="data.cardType === 'simple'" class="flex flex-col">
            <!-- Image (hidden below 576px, where it becomes a thumbnail beside the title) -->
            <div class="h-full cursor-pointer overflow-hidden rounded-lg relative mb-4 max-[576px]:hidden" [routerLink]="['/details', data.id]">
                <img *ngIf="data.imageUrl" [src]="data.imageUrl"
                    class="object-cover rounded-lg w-full h-48 absolute z-0 left-0 top-0 blur-md" />
                <img *ngIf="data.imageUrl" [src]="data.imageUrl"
                    class="object-contain rounded-lg w-full h-48 relative z-10" />
            </div>

            <div
                class="flex flex-col justify-between h-full gap-3 max-[576px]:p-4 max-[576px]:border max-[576px]:border-secondary-button-black max-[576px]:rounded-2xl">
                <div>
                    <div class="flex gap-4 mb-8 max-[576px]:gap-3 max-[576px]:mb-4">
                        <div class="hidden max-[576px]:block w-11 h-11 shrink-0 overflow-hidden rounded-lg cursor-pointer"
                            [routerLink]="['/details', data.id]">
                            <img *ngIf="data.imageUrl" [src]="data.imageUrl"
                                class="object-cover rounded-lg w-full h-full" />
                        </div>
                        <div class="w-86 max-[576px]:w-auto max-[576px]:flex-1 max-[576px]:min-w-0">
                            <a *ngIf="data?.title" routerLink="/details/{{data.id}}"
                                class="text-black text-base font-medium min-h-12 line-clamp-2 hover:underline overflow-hidden [overflow-wrap:anywhere]">
                                {{ data.title }}
                            </a>
                        </div>

                        <div class="flex flex-col items-center justify-center w-14">
                            <div class="relative w-[72px] h-full mb-2">
                                <svg class="absolute inset-0" viewBox="0 0 100 50">
                                    <path d="M 10,50 A 40,40 0 0 1 90,50" stroke="rgb(209, 213, 219)" stroke-width="8" fill="none" stroke-linecap="round" />
                                    <path d="M 10,50 A 40,40 0 0 1 90,50" [attr.stroke]="getIndicatorColor(data.winProbability)" stroke-width="8" fill="none" stroke-linecap="round" [style.stroke-dasharray]="'125.6'" [style.stroke-dashoffset]="125.6 - (getProgressPercentage(data.winProbability) * 1.256)" />
                                </svg>
                                <div class="absolute bottom-0 left-0 right-0 top-[20px] flex justify-center">
                                    <span class="text-sm font-semibold !leading-4" [style.color]="getIndicatorColor(data.winProbability)">
                                        {{ (data.winProbability !== undefined && data.winProbability !== null) ? data.winProbability + '%' : '50%' }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Dynamic Buttons -->
                    <div class="flex gap-2">
                        <ng-container *ngFor="let option of data.options | slice:0:2; let i = index">
                            <button
                                [class]="i === 0 ? 'text-sm font-syne flex-1 bg-[#1cae9133] text-[#1CAE91] rounded-lg py-1.5 px-4 font-semibold hover:bg-[#1CAE91] hover:text-white cursor-pointer transition-colors truncate' : 'text-sm font-syne flex-1 bg-[#f5d25533] text-[#DBA900] rounded-lg py-1.5 px-4 font-semibold hover:bg-[#DBA900] hover:text-white cursor-pointer transition-colors truncate'"
                                (click)="selectedCard(data.id, $any(option).title)">
                                {{ $any(option).title }}
                            </button>
                        </ng-container>
                        <!-- Fallback if no options mapped -->
                        <ng-container *ngIf="!data.options || data.options.length === 0">
                            <button class="text-sm font-syne flex-1 bg-[#1cae9133] text-[#1CAE91] rounded-lg py-1.5 px-4 font-semibold hover:bg-[#1CAE91] hover:text-white cursor-pointer transition-colors" (click)="selectedCard(data.id, 'YES')">Yes</button>
                            <button class="text-sm font-syne flex-1 bg-[#f5d25533] text-[#DBA900] rounded-lg py-1.5 px-4 font-semibold hover:bg-[#DBA900] hover:text-white cursor-pointer transition-colors" (click)="selectedCard(data.id, 'NO')">No</button>
                        </ng-container>
                    </div>
                </div>

                <!-- Footer with Volume and Icons -->
                <div class="flex justify-between">
                    <p class="text-xs flex items-center !leading-4 text-secondary-text-black gap-1">
                        ${{ data.volume }} Vol.
                        <ng-container *ngIf="data.frequency">
                            <button class="cursor-pointer">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-black opacity-50">
                                    <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
                                    <path d="M3 3v5h5" />
                                </svg>
                            </button>
                            <span class="text-xs flex items-center !leading-4 text-secondary-text-black gap-1">{{ data.frequency }}</span>
                        </ng-container>
                    </p>
                    <ul class="flex items-center gap-3.5">
                        <li class="inline-flex bg-transparent rounded-sm cursor-pointer p-1 duration-300 ease-in-out hover:bg-light-black-300">
                            <button class="cursor-pointer" (click)="toggleBookmark($event)">
                                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="14" viewBox="0 0 11 14" [attr.fill]="isBookmarked ? 'black' : 'none'">
                                    <path d="M0.5 10.242V5.19858C0.5 2.98365 0.5 1.87618 1.2142 1.18809C1.92841 0.5 3.07789 0.5 5.37687 0.5C7.67583 0.5 8.82537 0.5 9.53953 1.18809C10.2537 1.87618 10.2537 2.98365 10.2537 5.19858V10.242C10.2537 11.6477 10.2537 12.3506 9.78264 12.6021C8.87024 13.0893 7.15889 11.4639 6.34615 10.9746C5.8748 10.6907 5.63913 10.5488 5.37687 10.5488C5.11462 10.5488 4.87895 10.6907 4.4076 10.9746C3.59486 11.4639 1.88349 13.0893 0.971137 12.6021C0.5 12.3506 0.5 11.6477 0.5 10.242Z" [attr.stroke]="isBookmarked ? 'black' : 'black'" [attr.stroke-opacity]="isBookmarked ? '1' : '0.5'" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- Design 3: Sports Match Card -->
        <div *ngIf="data.cardType === 'sports'" class="flex flex-col h-full">
            <img *ngIf="data.imageUrl" [src]="data.imageUrl" class="object-cover rounded-lg w-full h-48 mb-4 cursor-pointer" [routerLink]="['/details', data.id]" />
            <a *ngIf="data?.title" routerLink="/details/{{data.id}}"
                class="text-black text-base font-medium line-clamp-2 mb-4 hover:underline overflow-hidden [overflow-wrap:anywhere]">
                {{ data.title }}
            </a>
            <div class="flex flex-col justify-between h-full">
                <div>
                    <div class="space-y-3 mb-6">
                        <div class="flex items-center justify-between gap-4">
                            <div class="flex items-center gap-3">
                                <div class="text-white text-[10px] font-syne font-bold w-[30px] h-[30px] bg-[#1CAE91] rounded-md flex items-center justify-center cursor-pointer transition-colors">
                                    <span class="leading-normal">LFC</span>
                                </div>
                                <span class="text-xs font-medium text-gray-800">{{ data.team1?.name }}</span>
                            </div>
                            <span class="text-sm font-semibold text-black">{{ data.team1?.odds }}</span>
                        </div>
                        <div class="flex items-center justify-between gap-4">
                            <div class="flex items-center gap-3">
                                <div class="text-white text-[10px] font-syne font-bold w-[30px] h-[30px] bg-[#E5B300] rounded-md flex items-center justify-center cursor-pointer transition-colors">
                                    <span class="leading-3">RM</span>
                                </div>
                                <span class="text-xs font-medium text-gray-800">{{ data.team2?.name }}</span>
                            </div>
                            <span class="text-sm font-semibold text-black">{{ data.team2?.odds }}</span>
                        </div>
                    </div>
                    <div class="grid grid-cols-3 gap-2 mb-5">
                        <button class="text-xs font-syne !leading-3.5 py-2 px-3 border-0 bg-[#1cae9133] border-gray-300 rounded-lg font-semibold text-[#1CAE91] hover:bg-[#1CAE91] hover:text-white transition-colors cursor-pointer" (click)="selectTeam('team1')">
                            {{ data.team1?.shortName || data.team1?.name }}
                        </button>
                        <button class="text-xs font-syne !leading-3.5 py-2 px-3 border border-[#00000033] rounded-lg font-semibold hover:border-black transition-colors cursor-pointer" (click)="selectTeam('draw')">
                            Draw
                        </button>
                        <button class="text-xs font-syne !leading-3.5 py-2 px-2 bg-[#f5d25533] text-[#DBA900] rounded-lg font-semibold hover:bg-[#DBA900] hover:text-white transition-colors cursor-pointer" (click)="selectTeam('team2')">
                            {{ data.team2?.shortName || data.team2?.name }}
                        </button>
                    </div>
                </div>
                <div class="flex justify-between items-center">
                    <div class="text-xs text-gray-500">
                        <span>{{ data.matchTime }}</span>
                        <span class="mx-2">•</span>
                        <span>{{ data.league }}</span>
                    </div>
                    <div class="flex items-center gap-1.5 text-sm text-gray-500">
                        <span>${{ data.volume }} Vol.</span>
                        <ng-container *ngIf="data.frequency">
                            <span class="mx-0.5">|</span>
                            <button class="cursor-pointer">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-gray-500">
                                    <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
                                    <path d="M3 3v5h5" />
                                </svg>
                            </button>
                            <span class="text-xs">{{ data.frequency }}</span>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
